'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'flask-round-potion';
var width = 448;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M160 186.8l0-19.4L160 32l128 0 0 135.4 0 19.4 17.2 9c56.4 29.4 94.8 88.3 94.8 156.1c-55.6-1.3-87.4-15.5-115.7-30.1c-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8c-6.6 3.5-12.4 6.9-17.4 10.2c8.9-55.8 44.1-102.9 92.6-128.2l17.2-9zm237.1 197c-6.9 37.6-25.6 71-52.3 96.2l-241.6 0c-31-29.2-51.3-69.5-54.7-114.4c1-.6 1.9-1.4 2.8-2.2c0 0 0 0 0 0s0 0 0 0l.2-.2c.3-.2 .7-.6 1.3-1.2c1.2-1.1 3.2-2.7 5.8-4.7c5.2-4 13.2-9.5 23.8-15C103.5 331.2 135 320 176 320c35.8 0 57.7 11.4 85.1 25.8c2.8 1.4 5.6 2.9 8.5 4.4c30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4s0 0 0 0s0 0 0 0c0 0 0 0 0 0zm0 0s0 0 0 0s0 0 0 0zM320 167.4L320 32l16 0 16 0 0-32L336 0 320 0 288 0 160 0 128 0 112 0 96 0l0 32 16 0 16 0 0 135.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;